<template>
    <div class="inner-box">
        <h2 class="title">{{title}}</h2>
        <div style="height:55px;"></div>
        <table class="visit-info-table">
            <tr>
                <th class="tit" v-for="label in labels">{{label.title}}</th>
            </tr>
            <tr class="boardLine" v-for="(item, index) in listItems" @click="readContent(item.id)">
                <td style="width:50px;text-align: center;">{{index+1}}</td>
                <td style="padding-left:30px">{{item.subject}}</td>
                <td style="width:150px;">{{item.regDtm}}</td>
            </tr>
        </table>
        <!--        <b-pagination :per-page="perPage" :total-rows="rows" align="center" v-model="currentPage"></b-pagination>-->
        <div class="btn">
            <button @click="writeContent">작성</button>&nbsp;
        </div>
    </div>
</template>

<script>
    export default {
        name: "termsListMng",
        data() {
            return {
                title: "신청약관",
                listItems: [],
                currentPage: 1, // 현재 페이지
                perPage: 10, // 페이지당 보여줄 갯수
                labels: [
                    {
                        key: 'number',
                        title: '번호'
                    },
                    {
                        key: "title",
                        title: "약관명"
                    },
                    {
                        key: "created_at",
                        title: "등록일"
                    }
                ],
            };
        },
        created() {
          //Admin 권한 체크
          if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
                  ,100});
            this.$router.push({path: `/ijmt`});
          };
        },
        methods: {
            getList() {
                this.$http.get(`/api/terms/list`)
                    .then(response => {
                        this.listItems = response.data;
                    });
            },
            writeContent() {
                this.$router.push({
                    path: '/backOffice/terms/create'
                });
            },
            readContent(id){
                this.$router.push({
                    path: `/backOffice/terms/detail/${id}`
                });
            }
        },
        mounted() {
            this.getList();
        }
    };

</script>
<style lang="scss" scoped>
    @import "public/css/bulma";

    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 59px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box ul{
        top: 30px;
        width: 100%;
        height: 60px;
        border:1px solid #d5d5d5;
    }

    .inner-box ul li{
        float: left;
        width: 33.3%;
        color: #888;
        text-align: center;
        display: block;
        line-height: 58px;
        font-weight: 700;
        border-right:1px solid #d5d5d5
    }

    .inner-box ul li:last-child{
        border-right:0;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box .btn{
        text-align:center;
    }

    .inner-box .on{
        background-color: #023e7c;
        color:#fff;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-info-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    table.visit-info-table th {
        border-bottom: 1px solid #ddd;
        color: #666;
        padding: 15px 10px 15px 10px;
        font-size: 14px;
        vertical-align: middle;
        background: #f9f9f9;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td input{
        width: 35%;
    }

    table.visit-info-table td p input{
        width: 100%;
    }

    table.visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    table.visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    table.visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td.list-c{
        text-align: center;
    }

    table.visit-info-table td button{
        margin-left:10px;
    }

    .boardLine:hover td{
        background: #efefef;
        color: #0a0a0a;
    }

</style>